import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function offerConfigReducer(state = initialState.offerConfig, action) {
  switch (action.type) {
    case types.LOAD_OFFER_CONFIG_SUCCESS: {
      return {
        ...action.payload.offerConfig,
        isLoaded: true
      };
    }

    default:
      return state;
  }
}
